import React from "react";
import { HeadLine } from "../modules/HeadLine";
import { AddAccount, PaymentMethodsTable } from "../modules/PaymentMethods";
import styled from "@emotion/styled";
import { PayPalCheckoutButton } from "../modules/PaymentMethods/Components/PayPalCheckoutButton";

const HeaderGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  margin-bottom: 1rem;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const AddAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  padding: 1rem;
  gap: 1rem;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
    align-items: center;
    padding: 0.5rem 0;
  }
`;

const PaymentMethodsContainer = styled.div`
  @media (min-width: 1024px) {
    height: calc(100vh - 250px);
    overflow-y: auto;
  }
`;

const PaymentMethods = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <HeaderGrid>
        <div>
          <HeadLine
            headingText={"Payment Methods"}
            tagLine={"Choose a default payment method or add a new one"}
          />
        </div>
        <AddAccountContainer>
          <AddAccount />
          <PayPalCheckoutButton />
        </AddAccountContainer>
      </HeaderGrid>
      <PaymentMethodsContainer>
        <PaymentMethodsTable />
      </PaymentMethodsContainer>
    </div>
  );
};

PaymentMethods.propTypes = {};

export default PaymentMethods;
